import { createReducer, createAction } from 'redux-act';
import toast from 'shared/utils/toast';

import {
  fetchData,
  createData,
  deleteDataById,
  updateDataById
} from 'services/asset/intermodalYardPlanning';

const initialState = {
  isFetching: true,
  data: [],
  isUpdate: false,
  error: false,
  message: ''
};

const fetchDataActionStart = createAction(
  'start fetch intermodal yard planning list'
);
const fetchDataActionSuccess = createAction(
  'fetch intermodal yard planning list success'
);
const fetchDataActionError = createAction(
  'fetch intermodal yard planning list error'
);

const createUpdateDataActionStart = createAction(
  'start create/update intermodal yard planning'
);
const createUpdateDataActionSucess = createAction(
  'create/update intermodal yard planning success'
);
const createUpdateDataActionError = createAction(
  'create/update intermodal yard planning error'
);

export default createReducer(
  {
    [fetchDataActionStart]: (state) => ({
      ...state,
      isFetching: true
    }),
    [fetchDataActionSuccess]: (state, payload) => ({
      ...state,
      isFetching: false,
      data: payload.data
    }),
    [fetchDataActionError]: (state) => ({
      ...state,
      isFetching: false,
      error: true,
      message: 'Have some errors while fetch data'
    }),
    [createUpdateDataActionStart]: (state) => ({
      ...state,
      isUpdate: true
    }),
    [createUpdateDataActionSucess]: (state) => ({
      ...state,
      isUpdate: false
    }),
    [createUpdateDataActionError]: (state) => ({
      ...state,
      isUpdate: false
    })
  },
  initialState
);

export const fetchIntermodalYardPlanningList = (companyId) => {
  return async (dispatch) => {
    try {
      dispatch(fetchDataActionStart());
      const res = await fetchData(companyId);
      dispatch(fetchDataActionSuccess({ data: res.data }));
    } catch (e) {
      dispatch(fetchDataActionError());
    }
  };
};

export const createIntermodalYardPlanningAction = (companyId, data) => {
  return async (dispatch) => {
    try {
      const res = await createData(companyId, data);
      if (res) {
        dispatch(createUpdateDataActionSucess());
        toast.success('Intermodal yard planning  has been created');
      }
    } catch (e) {
      dispatch(createUpdateDataActionError());
      toast.error('Error occurred when creating intermodal yard planning');
    }
  };
};

export const updateIntermodalYardPlanningAction = (id, companyId, data) => {
  return async (dispatch) => {
    try {
      const res = await updateDataById(id, companyId, data);
      if (res) {
        dispatch(createUpdateDataActionSucess());
        toast.success('Intermodal yard planning  has been updated');
      }
    } catch (e) {
      dispatch(createUpdateDataActionError());
      toast.error('Error occurred when updating intermodal yard planning');
    }
  };
};

export const deleteIntermodalYardPlanningAction = (id) => {
  return async (dispatch) => {
    try {
      const res = await deleteDataById(id);
      if (res) {
        dispatch(createUpdateDataActionSucess());
        toast.success('Intermodal yard planning  has been deleted');
      }
    } catch (e) {
      dispatch(createUpdateDataActionError());
      toast.error('Error occurred when deleting intermodal yard planning');
    }
  };
};
